// Tab Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import IntlMessage from '../../common/intl/intl_message.jsx'

class Tab extends Component {
  constructor (props) {
    super(props)

    this.state = {
      pointer: {},
      selected: 0,
      bChanged: false
    }

    this._references = {
      navigation: React.createRef()
    }
  }

  static get propTypes () {
    return {
      children: PropTypes.node.isRequired,
      onChange: PropTypes.func,
      showAll: PropTypes.bool,
      showFullBorder: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      onChange: null,
      showAll: false,
      showFullBorder: false
    }
  }

  render () {
    const _className = classnames(
      'tab',
      {
        tab_showall: this.props.showAll
      },
      ''
    )

    const style = { top: this.state.pointer.top }

    return (
      <div className={_className}>
        <div className='tabheader' ref={this._references.navigation}>
          {this._renderTabHeader()}
        </div>
        <span className='tabpointer' style={this.state.pointer} />
        {this.props.showFullBorder ? (
          <span className='tabpointer full' style={style} />
        ) : (
          ''
        )}
        <div className='tabcontent'>{this._renderTabPanels()}</div>
      </div>
    )
  }

  _triggerActiveIndex (props) {
    let activeIndex = this.state.selected
    props.children.map((item, index) => {
      if (item.props.active !== undefined && item.props.active === true) {
        activeIndex = index
      }
    })

    this._updatePointer(activeIndex)
    this.setState({ selected: activeIndex })
  }

  _onSelect (index, event) {
    event.preventDefault()
    this.setState({
      selected: index,
      bChanged: true
    })

    this._updatePointer(index)

    if (this.props.onChange) {
      this.props.onChange(index)
    }
  }

  componentDidMount () {
    this._triggerActiveIndex(this.props)
  }

  componentWillUnmount () {
    clearTimeout(this.pointerTimeout)
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    if (!this.pointerTimeout) {
      this._triggerActiveIndex(nextProps)
    }
  }

  /* Private Functions */
  _renderTabHeader () {
    if (!this.props.children) {
      return ''
    }

    return this.props.children.map((item, index) => {
      let activeIndex = this.state.selected
      if (
        item.props.active !== undefined &&
        item.props.active === true &&
        !this.state.bChanged
      ) {
        activeIndex = index
      }

      const _className = `tabheaderitem${
        activeIndex === index ? ' active' : ''
      }${item.props.disable ? ' disabled' : ''}`
      return (
        <div
          key={index}
          className={_className}
          onClick={this._onSelect.bind(this, index)}
        >
          <IntlMessage ident={item.props.title} />
        </div>
      )
    })
  }

  _renderTabPanels () {
    if (!this.props.children) {
      return ''
    }

    return this.props.children.map((item, index) => {
      let activeIndex = this.state.selected
      if (
        item.props.active !== undefined &&
        item.props.active === true &&
        !this.state.bChanged
      ) {
        activeIndex = index
      }

      const _className = `tabitemcont${activeIndex === index ? ' active' : ''}`
      if (activeIndex !== index && !this.props.showAll) {
        return ''
      }

      return (
        <div key={index} className={_className}>
          {item}
        </div>
      )
    })
  }

  _updatePointer (idx) {
    clearTimeout(this.pointerTimeout)
    this.pointerTimeout = setTimeout(() => {
      this.pointerTimeout = null

      if (this._references.navigation.current) {
        const label = this._references.navigation.current.children[idx]
        this.setState({
          pointer: {
            top: `${label.offsetHeight}px`,
            left: `${label.offsetLeft}px`,
            width: `${label.offsetWidth}px`
          }
        })
      }
    }, 20)
  }
}

export default Tab
